import * as React from 'react';
import { HTMLProps, useContext, useEffect } from 'react';
import { useTitle } from 'react-use';

import FixedAudioPlayer from 'src/components/FixedAudioPlayer/FixedAudioPlayer';
import GlobalAudioContext from 'src/contexts/GlobalAudioContext';

import './Layout.scss';

type Props = {
  children?: React.ReactNode;
  className: string;
  title?: string;
  closableAudioPlayer?: boolean;
  banner?: React.ReactNode;
  contentStyle?: HTMLProps<HTMLDivElement>['style'];
  contentProps?: HTMLProps<HTMLDivElement>;
} & HTMLProps<HTMLDivElement>;

function formatTitle(subTitle?: string): string {
  const baseTitle = 'Cortico';
  return subTitle ? `${subTitle} - ${baseTitle}` : baseTitle;
}

const Layout: React.FC<Props> = ({
  title,
  className,
  children,
  closableAudioPlayer = true,
  banner,
  style,
  contentStyle,
  contentProps = {},
  ...props
}) => {
  useTitle(formatTitle(title));
  const { stop } = useContext(GlobalAudioContext);

  useEffect(() => {
    stop(); // stop any playing audio when the layout mounts
  }, []);

  return (
    <div
      className={`Layout ${className}`}
      style={{ position: 'relative', ...style }}
      {...props}
    >
      {banner}
      <main
        role="main"
        className="main-content"
        style={contentStyle}
        {...contentProps}
      >
        {children}
      </main>
      <FixedAudioPlayer
        className="fixed-audio-player"
        closable={closableAudioPlayer}
      />
    </div>
  );
};

export default Layout;
